<template>
  <div>
<!--  <v-toolbar dense flat v-if="!!value" class="mr-n16">-->
<!--    <v-row class="flex-nowrap">-->
      <BaseTextSwitch
          v-for="item of barSwitches"
          v-model="item.on_off"
          :on-text="item.on_text"
          :off-text="item.off_text"
          :color="!item.on_off ? 'red lighten-1': null"
          @input="onChange()"
          v-bind="$attrs"
      >
      </BaseTextSwitch>
<!--    </v-row>-->
<!--  </v-toolbar>-->
  </div>
</template>

<script>
import BaseTextSwitch from "@/components/Base/BaseTextSwitch";
export default {
  name: 'CommonSwitchFilterGroup',
  inheritAttrs: false,
  props: {
    value: {default: null},
  },

  components: {
    BaseTextSwitch,
  },

  computed: {},

  methods: {
    getByFilterCount(filterItem) {
      // return this.itemList.filter(row => !!row[this.rowFilterNames] &&
      //     row.deleted === false &&
      //     row[this.rowFilterNames].includes(filterItem.name)).length
      return filterItem.count
    },
    onChange() {
      let selectedSwitches = {}
      this.barSwitches.forEach(row => selectedSwitches[row.name] = row.on_off)
      this.$emit('update:filter-names', selectedSwitches)
    },
  },

  async mounted() {
    this.barSwitches = structuredClone(this.value)
  },

  data() {
    return {
      selectedSwitches: {},
      barSwitches: {},
    }
  }
}
</script>

